import { z } from "zod";

import {
  enumeratedLiterals,
  type EnumeratedLiteralType,
} from "@north-beam/nb-common";

export const LoggerTransports = enumeratedLiterals(
  ["amplitude", "browser", "bugsnag"] as const,
  {},
);

/**
 * Represents the allowed mediums for which information can be transmitted by the {@link Logger}
 * when the relevant methods on the {@link Logger} are called.
 */
export type LoggerTransport = EnumeratedLiteralType<typeof LoggerTransports>;

export const LoggerTransportsSchema = z.array(LoggerTransports.schema);

export const LoggerLevels = enumeratedLiterals(
  ["error", "warn", "info", "debug", "silent"] as const,
  {},
);

/**
 * Represents the minimum level for which the {@link Logger} will emit events via transports that do
 * not include "bugsnag" or "amplitude".
 *
 * For "bugsnag" and "amplitude", the {@link LoggerLevel} is irrelevant - and the determination of
 * whether or not logs are emitted through those mediums is made solely based on the configuration
 * and environment.
 */
export type LoggerLevel = EnumeratedLiteralType<typeof LoggerLevels>;

export const LoggerEnvs = enumeratedLiterals(
  ["development", "production", "test"] as const,
  {},
);

export type LoggerEnv = EnumeratedLiteralType<typeof LoggerEnvs>;
